import {createProjectModel} from 'crm/utils/project-model'
import constants from 'crm/common/constants'
import {
    tasks,
    tasksChats,
    tasksDelete,
    tasksChatsDelete,
    tasksStatusModify,
    createTasksChats,
} from './service'

const model = createProjectModel({
    projectNamespace: 'groupSop',

    state: {
        tasksTableData: null,
    },

    effects: {
        *tasksDelete({payload}, {call}) {
            return yield call(tasksDelete, payload)
        },

        *tasksChatsDelete({payload}, {call}) {
            return yield call(tasksChatsDelete, payload)
        },

        *tasksStatusModify({payload}, {call}) {
            return yield call(tasksStatusModify, payload)
        },

        *createTasksChats({payload}, {call}) {
            return yield call(createTasksChats, payload)
        },

        *tasks(xx, {call, select, put}) {
            const {tasksTableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset:
                    tasksTableData.pagination.pageSize * (tasksTableData.pagination.current - 1),
                limit: tasksTableData.pagination.pageSize,
                ...tasksTableData.params,
            }

            newParams.start_time = `${
                tasksTableData.params?.time?.[0]?.format(constants.dateFormat) ?? ''
            }`
            newParams.end_time = `${
                tasksTableData.params?.time?.[1]?.format(constants.dateFormat) ?? ''
            }`

            delete newParams.time

            const res = yield call(tasks, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    // eslint-disable-next-line no-param-reassign
                    draft.tasksTableData.dataSource = res.data
                    // eslint-disable-next-line no-param-reassign
                    draft.tasksTableData.pagination.total = res?.pagination?.rows_found ?? 0
                },
            })
        },

        *tasksChats({payload}, {call}) {
            return yield call(tasksChats, payload)
        },
    },
})

export default model
